import USER_PERSONA_TYPES from '../../constants/userPersonas';

const getUserPersonaType = (
  faNumber,
  entityID,
  contactID,
  contactType,
  createTimeStamp,
  utmSource,
  locale
) => {
  if (faNumber) {
    if (contactID && contactType && createTimeStamp) {
      if (utmSource === 'branch_email') {
        return USER_PERSONA_TYPES.WORD_POWER;
      }
      if (contactType === 'C' && utmSource === 'newsletter') {
        return USER_PERSONA_TYPES.NEWS_LETTER;
      }
      return USER_PERSONA_TYPES.WORD_POWER;
    }
    return USER_PERSONA_TYPES.PERSONAL_LINK;
  }
  if (entityID) {
    return USER_PERSONA_TYPES.PERSONAL_LINK_FA_PROFILE;
  }
  if (locale === 'en_US') {
    return USER_PERSONA_TYPES.WEBSITE_PROSPECT;
  }
  if (locale === 'en_CA' || locale === 'fr_CA') {
    return USER_PERSONA_TYPES.DIRECT_URL_CA;
  }
  return USER_PERSONA_TYPES.DIRECT_URL;
};

export default getUserPersonaType;
